import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { changeOrder } from '../../actionCreators';
var mapStateToProps = function (state, _a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, parentId = _a.parentId;
    var _b = getThreadState(state, commentableTypeId, commentableItemId, parentId), streamId = _b.streamId, order = _b.order, total = _b.total;
    return {
        streamId: streamId,
        order: order,
        total: total,
    };
};
var mapDispatchToProps = {
    onOrderChanged: changeOrder,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ThreadHeader.container.js.map